import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
export default function FinancialDiffStatus(param) {
    var isDiffPO = param.isDiffPO;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            isDiffPO && /*#__PURE__*/ _jsxs("div", {
                className: "text-[#FF0000] mt-3 text-[12px] text-ellipsis overflow-hidden",
                children: [
                    /*#__PURE__*/ _jsx(CancelRoundedIcon, {
                        className: "mt-[-2px]"
                    }),
                    " มูลค่าไม่ตรงกับใบสั่งซื้อ PO"
                ]
            }),
            !isDiffPO && /*#__PURE__*/ _jsxs("div", {
                className: "text-[#10B02A] mt-3 text-[12px] text-ellipsis overflow-hidden",
                children: [
                    /*#__PURE__*/ _jsx(CheckCircleRoundedIcon, {
                        className: "mt-[-2px]"
                    }),
                    " มูลค่าตรงกับใบสั่งซื้อ PO"
                ]
            })
        ]
    });
}
